import { Integration, integrationTypes } from 'js/constants/externalIntegrations';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IntegrationList from 'src/new/components/settings/Integrations/IntegrationList';
import { loadGenAiConfigs, updateGenAiConfig } from 'js/actions/genAiConfigs';
import { find } from 'lodash';
import { DeactivateIntegration } from 'new/components/settings/Integrations/IntegrationList/DeactivateIntegration';
import { useModals } from 'new/hooks/useModals';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

const title = 'Integrate Nexla with Gen AI providers';
const description =
  "Meaningful resource documentation enables efficient data operations — it allows users to better understand resources and provides important information for triaging data flow. Empower your organization's users to easily add thorough AI-generated documentation to Nexla resources.";

export const GenAIIntegrations = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const { genAiConfigs } = useSelector((state: any) => state.entities);

  const { openModal } = useModals();

  useEffect(() => {
    dispatch(loadGenAiConfigs());
  }, []);

  const onActivationChange = (integration, genAiConfig) => (event, checked) => {
    if (!genAiConfig) {
      return;
    }

    // if another integration is active, pause it first
    const activeIntegration =
      integration.meta.type === integrationTypes.gen_ai &&
      find(
        genAiConfigs,
        (genAiConfig) =>
          genAiConfig.name !== integration.meta.name && genAiConfig.status === 'active',
      );

    if (checked) {
      if (activeIntegration) {
        // ask for confirmation to pause the currently active one
        openModal(DeactivateIntegration.modalConfig.name, {
          activeIntegration,
          integrationType: integrationTypes.gen_ai,
          currentIntegration: genAiConfig,
        });
      } else {
        dispatch(
          updateGenAiConfig(genAiConfig.id, {
            status: 'active',
          }),
        );
      }
    } else {
      dispatch(
        updateGenAiConfig(genAiConfig.id, {
          status: 'paused',
        }),
      );
    }
  };

  const itemAdapter = (integration: Integration) => {
    const genAiConfig =
      integration.meta.type === integrationTypes.gen_ai &&
      find(genAiConfigs, { type: integration.meta.name });
    const isActive = genAiConfig?.status === 'active';
    return (
      <IntegrationList.Item
        isActive={isActive}
        disableActivation={!genAiConfig}
        onActivationChange={onActivationChange(integration, genAiConfig)}
      />
    );
  };

  return (
    <IntegrationList
      title={title}
      description={description}
      itemAdapter={itemAdapter}
      integrationType={integrationTypes.gen_ai}
    />
  );
};
